import React from 'react';
import { connect } from 'react-redux';

import ApplyModal from 'src/universal/components/Modal/Variations/ApplyModal';

import { getPdpApplyModalData } from 'page_modules/business-pdp/redux';

const ApplyModalComponent = React.memo(({ applyModalData }) => {
  return (
    <ApplyModal
      data={applyModalData}
      modalName={`apply_${applyModalData?.shortName}`}
    />
  );
});

ApplyModalComponent.propTypes = {
  applyModalData: ApplyModal.propTypes.data
};

const mapStateToProps = state => ({
  applyModalData: getPdpApplyModalData(state)
});

export default connect(mapStateToProps)(ApplyModalComponent);
